import {Component, inject, ChangeDetectionStrategy} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogModule, MatDialogRef} from "@angular/material/dialog";
import {MatButtonModule} from "@angular/material/button";
import {Facility} from "../../../core/models/facility";
import {MatIconModule} from "@angular/material/icon";

export interface ChooseActiveFacilityData {
  facilities: Facility[];
  currentActiveFacilityId?: string;
}

@Component({
  selector: 'app-choose-active-facility-dialog',
  imports: [
    MatDialogModule,
    MatButtonModule,
    MatIconModule,
  ],
  templateUrl: './choose-active-facility-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './choose-active-facility-dialog.component.css'
})
export class ChooseActiveFacilityDialogComponent {
  data: ChooseActiveFacilityData = inject(MAT_DIALOG_DATA);
  dialogRef = inject(MatDialogRef<ChooseActiveFacilityDialogComponent>);

  chooseFacility(facility: Facility) {
    this.dialogRef.close({facility: facility});
  }
}
